/*@ngInject*/
const ChatMessageListRepository = function (baseRepository, currentSubmissionModel) {

    angular.extend(this, baseRepository);

    this.getChatMessageList = function (submissionId) {
        let url = '/rest/ChatMessage/List',
            params = {
                submissionId: submissionId,
                registrationIdentifier: '/Submission/' + submissionId
            };

        currentSubmissionModel.addRegistration({url: url, params: params});

        return this.get(url, {params: params});
    };
};

angular.module('gw-um-submission')
    .service('chatMessageListRepository', ChatMessageListRepository);
